//
//
//
//
import roseChart from '@/components/bigDataChart/roseChart';
import { querySiteInfo } from '@/api/api'; // import { listenMapChange } from '@/mixins/listenMapChange'

export default {
  name: 'waterStandard',
  //   mixins: [listenMapChange],
  created: function created() {
    this.queryWaterStandard();
  },
  props: {
    width: {
      type: String,
      default: '420px'
    },
    height: {
      type: String,
      default: '280px'
    }
  },
  components: {
    roseChart: roseChart
  },
  methods: {
    queryWaterStandard: function queryWaterStandard(areaId, projectId) {
      var _this = this;

      querySiteInfo().then(function (res) {
        console.log(res);
        var data = [{
          name: '站点数量',
          value: res.result.allSite
        }, {
          name: '通讯数量',
          value: res.result.onlineMsgSum
        }, {
          name: '预警数量',
          value: res.result.warnSum
        }, {
          name: '在线时长',
          value: 3687
        }];
        var dataText = res.result.online * 100 + "%";

        _this.$refs.chart5.initRoseChart(data, dataText);
      });
    }
  } //   watch: {
  //     currentProjectId(value) {
  //       this.queryWaterStandard(this.currentAreaId, value)
  //     },
  //     currentAreaId(value) {
  //       this.queryWaterStandard(value, this.currentProjectId)
  //     },
  //   },

};